export default "__VITE_ASSET__FVZYnhNx__";